/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import DS from 'ember-data';
import ApiErrorsService from 'cio/services/api-errors';
import { CampaignBroadcastStatLinkData } from 'cio/services/subscription-center';
import { CampaignState, CampaignType } from 'cio/models/campaign';
import { queryEncode } from 'cio/helpers/query';
import getUnsubscribedFilters from 'cio/utils/get-unsubscribed-filters';

interface DisableModalArgs {
  readOnly: boolean;
  subscribedPeopleTotal: number;
  disableSubscriptionCenter: () => unknown;
  onClose: () => unknown;
}

export default class DisableComponent extends Component<DisableModalArgs> {
  @service store!: DS.Store;
  @service apiErrors!: ApiErrorsService;

  @tracked stats: CampaignBroadcastStatLinkData[] | [] = [];

  get encodedSubscribedPeopleFilters() {
    return queryEncode(getUnsubscribedFilters(null, false) as Record<string, any>);
  }

  @action
  async didInsert() {
    this.stats = await this.fetchStats.perform();
  }

  fetchStats = task(async () => {
    try {
      let [campaigns, newsletters, apiTriggeredBroadcasts] = await Promise.all([
        this.store.query('campaign', {
          archived: false,
          state: CampaignState.Running,
        }),
        this.store.query('newsletter', { type: 'scheduled' }),
        this.store.query('campaign', { state: CampaignState.Running, type: CampaignType.APITriggered }),
      ]);

      return [
        {
          name: 'running campaign',
          count: campaigns.toArray().length,
          route: 'campaigns',
          query: { state: CampaignState.Running },
        },
        {
          name: 'scheduled newsletter',
          count: newsletters.filterBy('isScheduled').toArray().length,
          route: 'broadcasts.list.newsletters',
          query: { type: 'scheduled' },
        },
        {
          name: 'API triggered broadcast',
          count: apiTriggeredBroadcasts.toArray().length,
          route: 'broadcasts.list.api-triggered',
          query: { state: CampaignState.Running, type: CampaignType.APITriggered },
        },
      ].filterBy('count');
    } catch (e) {
      this.apiErrors.report(e);
    }
    return [];
  });

  @action
  async disableCenterAndCloseModal() {
    await this.args.disableSubscriptionCenter();
    this.args.onClose();
  }
}
